(function () {
'use strict';

// --- Live search ---	
var uxLiveSearch = function(item) {

	this.item = item;

	
	if(!this.hasOwnProperty('item')){
		
		return false;

	}


	this._init();

};


uxLiveSearch.prototype = {

	_init: function() {

		this.searchInput = this.item.querySelector('.live-search__input');
		this.searchItems = this.item.querySelectorAll('[data-live-search-item]');


		this._event();				

	},


	_event: function() {

		this.searchInput.addEventListener('input', this._event_search.bind(this), false);

	},


	_event_search: function() {

		let	itemValue = null,			 
			target = event.target,
			targetValue = target.value.toLowerCase();

		
		this.searchItems.forEach((item, index, array) => {

			itemValue = item.dataset.liveSearchItem.toLowerCase();
			
			if (itemValue.search(targetValue) < 0) {

				item.classList.add('hide');

			} else {
				
				item.classList.remove('hide');

			}	

		});			

	}

};



// --- /Live search ---

// --- page main script ---				
var pageHospitalCenterScript = function(item) {

	this.item = item;

	
	if (!this.hasOwnProperty('item')) {
		
		return false;

	}


	this._init();

};


pageHospitalCenterScript.prototype = {

	_init: function() {

		if (this.item.querySelector('.hc-service') !== null) {

			this._variable();
			this._event();

		}

	},


	_variable: function() {

		// "Услуги, операции и цены"
		this.hsService = this.item.querySelector('.hc-service');
		this.hcServiceCategoryContainer = this.hsService.querySelector('.list-service-category');

	},


	_event: function() {

		// "Услуги, операции и цены"
		if (this.hsService.classList.contains('live-search__js') == true) {

			this.hcServiceCategoryContainer.addEventListener('change', this._event_change_hcService.bind(this), false);
		
		}
	
	},


	// "Услуги, операции и цены": повторно инициализируем live-search, когда меняется или дополняется список услуг 
	_event_change_hcService: function() {
		
		let uxLiveSearchInitService = new uxLiveSearch(this.hsService);

	}

};
// --- /page main script ---



// init
document.addEventListener('DOMContentLoaded', function() {

	var pageHospitalCenterElement = document.querySelector('.hc');


	if (pageHospitalCenterElement !== null) {
		
		let pageHospitalCenterScriptInit = new pageHospitalCenterScript(pageHospitalCenterElement);

	}

});

}());
